import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { adminCreateIngredient } from '@api/adminIngredients';
import {
  adminDeactivateSupplement,
  adminMedicationInquiryDetails,
  adminSupplementInquiryDetails,
  adminSupplementRenew,
} from '@api/adminSupplements';
import { IAdminMedicationInquiryDetails } from '@interfaces/adminMedications';
import {
  IAdminSupplementInquiryDetails,
  IAdminSupplementRenewPayload,
} from '@interfaces/adminSupplements';

export const handleGetAdminSupplementDetails = createAsyncThunk<
  AxiosResponse<IAdminSupplementInquiryDetails>,
  number
>('getAdminSupplementDetails', adminSupplementInquiryDetails);

export const handleAdminSupplementRenew = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminSupplementRenewPayload
>('adminSupplementRenew', adminSupplementRenew);

export const handleAdminDeactivateSupplement = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  number
>('adminDeactivateSupplement', adminDeactivateSupplement);

export const handleGetAdminMedicationDetails = createAsyncThunk<
  AxiosResponse<IAdminMedicationInquiryDetails>,
  number
>('getAdminMedicationDetails', adminMedicationInquiryDetails);
